// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"c41192fa","366":"56e58e9e","537":"224f60f0","657":"258c6a0b","742":"45e986b7"}[chunkId] + ".chunk.css";
};